import { useTranslation } from 'react-i18next'

import { MANAGEMENT_TYPE } from '../../config/constants'
import type { Tenant } from '../../types/tenant'

import type { TenantTypeProps } from './TypeBadge.types'

type BadgeStylesKeys = 'Platform' | 'Standalone' | 'default'

const TypeBadge = (props: TenantTypeProps) => {
  const { type } = props
  const { t } = useTranslation()
  const managementType = type as Tenant['managementType']

  const getTranslationKey = (type: string): BadgeStylesKeys | string => {
    switch (type) {
      case MANAGEMENT_TYPE.PLATFORM:
        return 'Platform'
      case MANAGEMENT_TYPE.STANDALONE:
        return 'Standalone'
      default:
        return type
    }
  }

  const badgeStyles: Record<BadgeStylesKeys, string> = {
    Platform: 'bg-purple-100 text-purple-800',
    Standalone: 'bg-blue-100 text-blue-800',
    default: 'bg-yellow-100 text-yellow-800',
  }

  const translationKey = getTranslationKey(managementType)

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${
        badgeStyles[translationKey as BadgeStylesKeys] || badgeStyles.default
      }`}
    >
      {t(`Tenants.Type.${translationKey}`)}
    </span>
  )
}

export default TypeBadge
